import { Answer, Content, Score } from "../types";

export function markAnswer(content: Content, answer: Answer): Score {
  if (!answer) {
    return {
      score: 0
    };
  }

  const allAnswers = content.toggles.length;
  const correctAnswer = content.toggles.map(answer => answer.correctAnswer);
  var correctAnswers = 0;
  answer.forEach((answer: any, i: number) => {
    if (answer === correctAnswer[i]) {
      correctAnswers++;
    }
  });

  //rounding needed for reasonable testing
  const score = parseFloat((correctAnswers / allAnswers).toPrecision(4));

  return {
    score: score
  };
}
